import { isArray } from 'lodash';
import React from 'react';
import { Select, MultiSelect } from '@grafana/ui';

function VariableValueSelect({ model }) {
  const { value, key, loading } = model.useState();
  return /* @__PURE__ */ React.createElement(Select, {
    id: key,
    placeholder: "Select value",
    width: "auto",
    value,
    allowCustomValue: true,
    tabSelectsValue: false,
    isLoading: loading,
    options: model.getOptionsForSelect(),
    onChange: (newValue) => {
      model.changeValueTo(newValue.value, newValue.label);
    }
  });
}
function VariableValueSelectMulti({ model }) {
  const { value, key, loading } = model.useState();
  const arrayValue = isArray(value) ? value : [value];
  return /* @__PURE__ */ React.createElement(MultiSelect, {
    id: key,
    placeholder: "Select value",
    width: "auto",
    value: arrayValue,
    tabSelectsValue: false,
    allowCustomValue: true,
    isLoading: loading,
    options: model.getOptionsForSelect(),
    closeMenuOnSelect: false,
    isClearable: true,
    onOpenMenu: () => {
    },
    onChange: (newValue) => {
      model.changeValueTo(
        newValue.map((v) => v.value),
        newValue.map((v) => v.label)
      );
    }
  });
}
function renderSelectForVariable(model) {
  if (model.state.isMulti) {
    return /* @__PURE__ */ React.createElement(VariableValueSelectMulti, {
      model
    });
  } else {
    return /* @__PURE__ */ React.createElement(VariableValueSelect, {
      model
    });
  }
}

export { VariableValueSelect, VariableValueSelectMulti, renderSelectForVariable };
//# sourceMappingURL=VariableValueSelect.js.map
